import { TableCellJsx } from 'src/components/table-cell-jsx';

export default TableCellJsx;
